// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

ion-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin: 10px;
  --background: none;
  --highlight-color:none;
}

p {
  text-align: center;
}

.auth-app p {
  color: #333333;
  font-family: var(--font-secondary) !important;
  font-weight: 500;
  font-size: 22px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/authenticator/verify-authapp/verify-authapp.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EACA,YAAA;AACJ;;AAEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAGI;EACE,cAAA;EACA,6CAAA;EACA,gBAAA;EACA,eAAA;AAAN","sourcesContent":[".input-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px;\r\n  }\r\n  \r\n  ion-input {\r\n    width: 40px;\r\n    height: 40px;\r\n    text-align: center;\r\n    font-size: 24px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    margin: 10px;\r\n    --background: none;\r\n    --highlight-color:none;\r\n  }\r\n\r\n  p{\r\n    text-align: center;\r\n  }\r\n\r\n  .auth-app{\r\n    p{\r\n      color: #333333;\r\n      font-family: var(--font-secondary) !important;\r\n      font-weight: 500;\r\n      font-size: 22px;\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
